import { render } from "./ClassgroupExercises.vue?vue&type=template&id=73702dbe&scoped=true&ts=true"
import script from "./ClassgroupExercises.vue?vue&type=script&lang=ts"
export * from "./ClassgroupExercises.vue?vue&type=script&lang=ts"

import "./ClassgroupExercises.vue?vue&type=style&index=0&id=73702dbe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73702dbe"]])

export default __exports__